const blockedHosts = new Set([
  "example.com",
  "www.example.com",
  "test.com",
  "www.test.com",
  "localhost",
]);

const blockedSuffixes = [
  ".example",
  ".invalid",
  ".localhost",
  ".local",
  ".test",
];

const isIpAddress = (host) => (
  /^(\d{1,3}\.){3}\d{1,3}$/.test(host)
  || host.includes(":")
);

export const getSafeExternalUrl = (value) => {
  if (!value || typeof value !== "string") return "";

  try {
    const url = new URL(value.trim());
    const host = url.hostname.toLowerCase().replace(/\.$/, "");

    if (url.protocol !== "https:") return "";
    if (!host || blockedHosts.has(host)) return "";
    if (!host.includes(".") || isIpAddress(host)) return "";
    if (blockedSuffixes.some((suffix) => host.endsWith(suffix))) return "";

    return url.toString();
  } catch (error) {
    return "";
  }
};
